import _implicitStylesheets from "./authenticatedContainer.css";
import _implicitScopedStylesheets from "./authenticatedContainer.scoped.css?scoped=true";
import _pageHeaderContainer from "page/headerContainer";
import _pageFooterContainer from "page/footerContainer";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "authenticated-container": true
  },
  key: 0
};
const stc1 = {
  key: 1
};
const stc2 = {
  classMap: {
    "page-container": true
  },
  key: 2
};
const stc3 = {
  key: 4
};
const stc4 = {
  key: 5
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, ncls: api_normalize_class_name, ddc: api_deprecated_dynamic_component, h: api_element} = $api;
  return [api_element("div", stc0, [api_custom_element("page-header-container", _pageHeaderContainer, stc1), api_element("div", stc2, [api_element("span", {
    className: api_normalize_class_name($cmp.isLoadingClass),
    key: 3
  }, [api_deprecated_dynamic_component("x-lazy", $cmp.pageComponent, stc3)])]), api_custom_element("page-footer-container", _pageFooterContainer, stc4)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3ra3hni23ep";
tmpl.legacyStylesheetToken = "page-authenticatedContainer_authenticatedContainer";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
